// extracted by mini-css-extract-plugin
export default {"roomCardSwiper":"BestCarDetails_roomCardSwiper__BXS9r"};